import formBaseMixin from  '../../../components/form/form-base-mixin.js'

export default {
  mixins: [formBaseMixin],
  data () {
    return {
      fields: {
        code: '',
        _computedCode: '',
        danger: '',
        parent_id: '',
        name: '',
        parentIdName: '',
        is_tko: false,
        is_rso: false,
        is_battery: false,
        is_bio: false,
        is_production: false,
        is_build: false,
        is_liquid: false,
        is_med: false,
        is_fkko: false
      }
    }
  },
  watch: {
    'fields': {
      handler: 'onFieldsUpdate',
      deep: true
    }
  },
  computed: {
    groupRequired () {
      if (this.$route.params.id && !this.item.parent_id) {
        return false
      }
      return true
    },
    dangerOptions () {
      return [
        {id: 1, name: 1},
        {id: 2, name: 2},
        {id: 3, name: 3},
        {id: 4, name: 4},
        {id: 5, name: 5}
      ]
    },
    states () {
      return this.$store.getters.readUrlEndpoint(this.getItemState()).data
    },
    fkkoChilds () {
      return this.$store.getters.readUrlEndpoint(this.getFkkoChilds(this.$route)).data
    },
    isRegional () {
      // enable all fileds in create
      if (!this.$route.params.id) {
        return true
      }
      if (this.item && this.item.reg_code) {
        return true
      }
      return false
    },
    isNoGroup () {
      if (this.$route.params.id && this.item && this.item.code && !this.item.code.endsWith('0')) {
        return true
      }
      return false
    }
  },
  methods: {
    onSuccess (r) {
      this.showOnSuccess('Запись сохранена')
      this.unFreezeFrom()
      this.$router.push(this.getRedirectParams())
    },
    prepareFieldsForSend (fields) {
      if (this.isRegional === true) {
        fields.code = parseInt(fields._computedCode.replace(/ /g, ''))
      } else {
        fields.code = parseInt(fields.code.replace(/ /g, ''))
      }
      console.log(fields)
      return fields
    },
    findFkkoById (id) {
      let index = this.fkkoChilds.findIndex(v => +v.id === +id)
      if (index > -1) {
        return this.fkkoChilds[index]
      } else {
        return {}
      }
    },
    findFkkoByParentId (parentId) {
      let index = this.fkkoChilds.findIndex(v => +v.parent_id === +parentId)
      if (index > -1) {
        return this.fkkoChilds[index]
      } else {
        return {}
      }
    },
    onFieldsUpdate () {
      if (this.isRegional === false) {
        return
      }
      let fkko = this.findFkkoById(this.fields.parent_id)
      this.$set(this.fields, 'name', fkko.name)
      let code = fkko.code || '0'
      code = code.toString()
      if (code.length > 0) {
        code = code.substring(0, code.length - 2)
      }
      this.$set(this.fields, '_computedCode', `${code} ${this.fields.danger || 0}`)
    },
    update () {
      if (this.item) {
        let fkko = this.findFkkoById(this.item.parent_id)
        console.log('fkko', fkko)
        this.fields = Object.assign({}, this.item)
        this.$set(this.fields, 'parentIdName', fkko.name)
      }
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemState()}))
    promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getFkkoChilds(route)}))

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}

